import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img02.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#262032" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Leading the Shift in Business Digitization for Boston</h2>
            <p>
              At TekRevol, we grasp the ever-changing dynamics within Boston’s
              development landscape. Our dedication to leading the way empowers
              us to construct resilient mobile apps that redefine effectiveness.
              Within Boston’s dynamic development sector, change remains
              ongoing. Our proactive stance in identifying emerging trends and
              shifting requirements enables us to shape mobile apps that align
              with the industry's evolving demands. The strategies we build for
              mobile app development are grounded in resolving real-world
              hurdles confronted by Boston’s development experts. Be it
              enhancing stakeholder communication, streamlining application
              processing, or amplifying transparency, our apps are crafted with
              a solution-driven approach that instigates positive
              transformation.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#262032",
                border: "1px solid #262032",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
